"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartYScale = exports.LineChartBgScale = exports.ChartXScale = void 0;
var react_1 = __importStar(require("react"));
var Chart_1 = require("./Chart");
function ChartXScale(_a) {
    var chart = _a.chart, style = _a.style;
    var ScaleLabel = (0, react_1.useCallback)(function (_a) {
        var value = _a.value, c = _a.c;
        var getLabel = chart.xLabelFunction || function (v) { return Math.round(v); };
        return react_1.default.createElement("div", { className: "x-scale-label ".concat(c || ''), style: { left: Math.round(chart.xNormalizer.normalize(value)) + "px" } }, getLabel(value));
    }, [chart.xNormalizer]);
    var xNormalizer = chart.xNormalizer;
    var maxEntries = (0, react_1.useMemo)(function () { return (0, Chart_1.countMaxEntries)(chart.data); }, [chart.data]);
    return react_1.default.createElement("div", { className: "chart-x-scale", style: __assign(__assign({}, style), { height: "30px" }) },
        react_1.default.createElement(ScaleLabel, { value: xNormalizer.dataMin + (xNormalizer.dataMax - xNormalizer.dataMin) * .5, c: 'center' }),
        maxEntries > 1 && react_1.default.createElement(ScaleLabel, { value: xNormalizer.dataMin, c: 'min' }),
        maxEntries > 1 && react_1.default.createElement(ScaleLabel, { value: xNormalizer.dataMax, c: 'max' }));
}
exports.ChartXScale = ChartXScale;
function LineChartBgScale() {
    var _a = (0, react_1.useContext)(Chart_1.ChartContext), yNormalizer = _a.yNormalizer, width = _a.width, marginBottom = _a.marginBottom, height = _a.height, yDataMinZero = _a.yDataMinZero, hintScales = _a.hintScales;
    var middle = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .5;
    var middleTop = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .25;
    var middleBottom = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .75;
    if (yDataMinZero)
        middle = yNormalizer.min + (yNormalizer.dataMax - yNormalizer.min) * .5;
    function shouldRender(n) {
        if (!hintScales)
            return true;
        n = yNormalizer.normalize(n);
        return hintScales.find(function (s) { return Math.abs(n - yNormalizer.normalize(s.value)) < 5; }) == null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        shouldRender(yNormalizer.dataMax) && react_1.default.createElement("path", { className: 'scale', d: "M 0 ".concat(yNormalizer.normalize(yNormalizer.dataMax), " L ").concat(width, " ").concat(yNormalizer.normalize(yNormalizer.dataMax)) }),
        marginBottom !== 0 && shouldRender(yNormalizer.dataMin) && react_1.default.createElement("path", { className: 'scale', d: "M 0 ".concat(yNormalizer.normalize(yNormalizer.dataMin), " L ").concat(width, " ").concat(yNormalizer.normalize(yNormalizer.dataMin)) }),
        shouldRender(middle) && react_1.default.createElement("path", { className: 'scale', d: "M 0 ".concat(yNormalizer.normalize(middle), " L ").concat(width, " ").concat(yNormalizer.normalize(middle)) }),
        height > 250 && shouldRender(middleTop) && react_1.default.createElement("path", { className: 'scale lighter', d: "M 0 ".concat(yNormalizer.normalize(middleTop), " L ").concat(width, " ").concat(yNormalizer.normalize(middleTop)) }),
        height > 250 && shouldRender(middleBottom) && react_1.default.createElement("path", { className: 'scale lighter', d: "M 0 ".concat(yNormalizer.normalize(middleBottom), " L ").concat(width, " ").concat(yNormalizer.normalize(middleBottom)) }),
        hintScales && hintScales.map(function (s) { var _a, _b; return react_1.default.createElement("path", { className: "scale hint ".concat((_a = s.style) !== null && _a !== void 0 ? _a : 'color1', " ").concat((_b = s.type) !== null && _b !== void 0 ? _b : 'dashed'), d: "M 0 ".concat(yNormalizer.normalize(s.value), " L ").concat(width, " ").concat(yNormalizer.normalize(s.value)) }); }));
}
exports.LineChartBgScale = LineChartBgScale;
function ChartYScale(_a) {
    var chart = _a.chart;
    var yNormalizer = chart.yNormalizer;
    var height = chart.height;
    var div = (0, react_1.useRef)(null);
    var ScaleLabel = (0, react_1.useCallback)(function (_a) {
        var value = _a.value, c = _a.c;
        var getLabel = chart.yLabelFunction || function (v) { return Math.round(v); };
        return react_1.default.createElement("div", { className: "y-scale-label ".concat(c || ''), style: { top: chart.yNormalizer.normalize(value) + "px" } }, getLabel(value));
    }, []);
    var middle = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .5;
    var middleTop = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .25;
    var middleBottom = yNormalizer.dataMin + (yNormalizer.dataMax - yNormalizer.dataMin) * .75;
    if (chart.yDataMinZero)
        middle = yNormalizer.min + (yNormalizer.dataMax - yNormalizer.min) * .5;
    (0, react_1.useEffect)(function () {
        var widths = Array.from(div.current.querySelectorAll('.y-scale-label')).map(function (d) { return d.clientWidth; });
        var maxWidth = widths.reduce(function (v, c) { return Math.max(v, c); }, 0);
        div.current.style.width = (maxWidth + 10) + "px";
    }, [chart.height]);
    return react_1.default.createElement("div", { className: 'chart-y-scale', ref: div },
        chart.marginBottom !== 0 && react_1.default.createElement(ScaleLabel, { value: yNormalizer.dataMin, c: "" }),
        react_1.default.createElement(ScaleLabel, { value: middle, c: "" }),
        react_1.default.createElement(ScaleLabel, { value: yNormalizer.dataMax, c: "" }),
        height > 250 && react_1.default.createElement(ScaleLabel, { value: middleTop, c: "lighter" }),
        height > 250 && react_1.default.createElement(ScaleLabel, { value: middleBottom, c: "lighter" }));
}
exports.ChartYScale = ChartYScale;
//# sourceMappingURL=scales.js.map